import React from 'react';
import { func, string } from 'prop-types';
import cn from 'classnames';
import WithPlaceholder from '../../hoc/WithPlaceholder';

const propTypes = {
  onChange: func.isRequired,
  query: string,
};
const defaultProps = {
  query: '',
  placeholder: '',
  defaultMessage: '',
};

const Search = ({ onChange, query, placeholder, defaultMessage, className }) => (
  <div className={cn('search-field', className)}>
    <WithPlaceholder
      placeholder={placeholder}
      defaultMessage={defaultMessage}
      bsSize="xs"
      type="text"
      onChange={onChange}
      value={query}
      autoComplete="off"
    />
  </div>
);

Search.propTypes = propTypes;
Search.defaultProps = defaultProps;

export default Search;
